import { __assign } from "tslib";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
export var ResponseHeadersPolicyAccessControlAllowMethodsValues;
(function (ResponseHeadersPolicyAccessControlAllowMethodsValues) {
    ResponseHeadersPolicyAccessControlAllowMethodsValues["ALL"] = "ALL";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["DELETE"] = "DELETE";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["GET"] = "GET";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["HEAD"] = "HEAD";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["OPTIONS"] = "OPTIONS";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["PATCH"] = "PATCH";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["POST"] = "POST";
    ResponseHeadersPolicyAccessControlAllowMethodsValues["PUT"] = "PUT";
})(ResponseHeadersPolicyAccessControlAllowMethodsValues || (ResponseHeadersPolicyAccessControlAllowMethodsValues = {}));
export var KeyPairIds;
(function (KeyPairIds) {
    KeyPairIds.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KeyPairIds || (KeyPairIds = {}));
export var KGKeyPairIds;
(function (KGKeyPairIds) {
    KGKeyPairIds.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KGKeyPairIds || (KGKeyPairIds = {}));
export var ActiveTrustedKeyGroups;
(function (ActiveTrustedKeyGroups) {
    ActiveTrustedKeyGroups.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ActiveTrustedKeyGroups || (ActiveTrustedKeyGroups = {}));
export var Signer;
(function (Signer) {
    Signer.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Signer || (Signer = {}));
export var ActiveTrustedSigners;
(function (ActiveTrustedSigners) {
    ActiveTrustedSigners.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ActiveTrustedSigners || (ActiveTrustedSigners = {}));
export var Aliases;
(function (Aliases) {
    Aliases.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Aliases || (Aliases = {}));
export var AliasICPRecordal;
(function (AliasICPRecordal) {
    AliasICPRecordal.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AliasICPRecordal || (AliasICPRecordal = {}));
export var CachedMethods;
(function (CachedMethods) {
    CachedMethods.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachedMethods || (CachedMethods = {}));
export var AllowedMethods;
(function (AllowedMethods) {
    AllowedMethods.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AllowedMethods || (AllowedMethods = {}));
export var AssociateAliasRequest;
(function (AssociateAliasRequest) {
    AssociateAliasRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AssociateAliasRequest || (AssociateAliasRequest = {}));
export var CookieNames;
(function (CookieNames) {
    CookieNames.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CookieNames || (CookieNames = {}));
export var CookiePreference;
(function (CookiePreference) {
    CookiePreference.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CookiePreference || (CookiePreference = {}));
export var Headers;
(function (Headers) {
    Headers.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Headers || (Headers = {}));
export var QueryStringCacheKeys;
(function (QueryStringCacheKeys) {
    QueryStringCacheKeys.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryStringCacheKeys || (QueryStringCacheKeys = {}));
export var ForwardedValues;
(function (ForwardedValues) {
    ForwardedValues.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ForwardedValues || (ForwardedValues = {}));
export var FunctionAssociation;
(function (FunctionAssociation) {
    FunctionAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FunctionAssociation || (FunctionAssociation = {}));
export var FunctionAssociations;
(function (FunctionAssociations) {
    FunctionAssociations.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FunctionAssociations || (FunctionAssociations = {}));
export var LambdaFunctionAssociation;
(function (LambdaFunctionAssociation) {
    LambdaFunctionAssociation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LambdaFunctionAssociation || (LambdaFunctionAssociation = {}));
export var LambdaFunctionAssociations;
(function (LambdaFunctionAssociations) {
    LambdaFunctionAssociations.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LambdaFunctionAssociations || (LambdaFunctionAssociations = {}));
export var TrustedKeyGroups;
(function (TrustedKeyGroups) {
    TrustedKeyGroups.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TrustedKeyGroups || (TrustedKeyGroups = {}));
export var TrustedSigners;
(function (TrustedSigners) {
    TrustedSigners.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TrustedSigners || (TrustedSigners = {}));
export var CacheBehavior;
(function (CacheBehavior) {
    CacheBehavior.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CacheBehavior || (CacheBehavior = {}));
export var CacheBehaviors;
(function (CacheBehaviors) {
    CacheBehaviors.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CacheBehaviors || (CacheBehaviors = {}));
export var CachePolicyCookiesConfig;
(function (CachePolicyCookiesConfig) {
    CachePolicyCookiesConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicyCookiesConfig || (CachePolicyCookiesConfig = {}));
export var CachePolicyHeadersConfig;
(function (CachePolicyHeadersConfig) {
    CachePolicyHeadersConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicyHeadersConfig || (CachePolicyHeadersConfig = {}));
export var QueryStringNames;
(function (QueryStringNames) {
    QueryStringNames.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryStringNames || (QueryStringNames = {}));
export var CachePolicyQueryStringsConfig;
(function (CachePolicyQueryStringsConfig) {
    CachePolicyQueryStringsConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicyQueryStringsConfig || (CachePolicyQueryStringsConfig = {}));
export var ParametersInCacheKeyAndForwardedToOrigin;
(function (ParametersInCacheKeyAndForwardedToOrigin) {
    ParametersInCacheKeyAndForwardedToOrigin.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ParametersInCacheKeyAndForwardedToOrigin || (ParametersInCacheKeyAndForwardedToOrigin = {}));
export var CachePolicyConfig;
(function (CachePolicyConfig) {
    CachePolicyConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicyConfig || (CachePolicyConfig = {}));
export var CachePolicy;
(function (CachePolicy) {
    CachePolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicy || (CachePolicy = {}));
export var CachePolicySummary;
(function (CachePolicySummary) {
    CachePolicySummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicySummary || (CachePolicySummary = {}));
export var CachePolicyList;
(function (CachePolicyList) {
    CachePolicyList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CachePolicyList || (CachePolicyList = {}));
export var CreateCachePolicyRequest;
(function (CreateCachePolicyRequest) {
    CreateCachePolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCachePolicyRequest || (CreateCachePolicyRequest = {}));
export var CreateCachePolicyResult;
(function (CreateCachePolicyResult) {
    CreateCachePolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCachePolicyResult || (CreateCachePolicyResult = {}));
export var CloudFrontOriginAccessIdentityConfig;
(function (CloudFrontOriginAccessIdentityConfig) {
    CloudFrontOriginAccessIdentityConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CloudFrontOriginAccessIdentityConfig || (CloudFrontOriginAccessIdentityConfig = {}));
export var CreateCloudFrontOriginAccessIdentityRequest;
(function (CreateCloudFrontOriginAccessIdentityRequest) {
    CreateCloudFrontOriginAccessIdentityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCloudFrontOriginAccessIdentityRequest || (CreateCloudFrontOriginAccessIdentityRequest = {}));
export var CloudFrontOriginAccessIdentity;
(function (CloudFrontOriginAccessIdentity) {
    CloudFrontOriginAccessIdentity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CloudFrontOriginAccessIdentity || (CloudFrontOriginAccessIdentity = {}));
export var CreateCloudFrontOriginAccessIdentityResult;
(function (CreateCloudFrontOriginAccessIdentityResult) {
    CreateCloudFrontOriginAccessIdentityResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCloudFrontOriginAccessIdentityResult || (CreateCloudFrontOriginAccessIdentityResult = {}));
export var CustomErrorResponse;
(function (CustomErrorResponse) {
    CustomErrorResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CustomErrorResponse || (CustomErrorResponse = {}));
export var CustomErrorResponses;
(function (CustomErrorResponses) {
    CustomErrorResponses.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CustomErrorResponses || (CustomErrorResponses = {}));
export var DefaultCacheBehavior;
(function (DefaultCacheBehavior) {
    DefaultCacheBehavior.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DefaultCacheBehavior || (DefaultCacheBehavior = {}));
export var LoggingConfig;
(function (LoggingConfig) {
    LoggingConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LoggingConfig || (LoggingConfig = {}));
export var StatusCodes;
(function (StatusCodes) {
    StatusCodes.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StatusCodes || (StatusCodes = {}));
export var OriginGroupFailoverCriteria;
(function (OriginGroupFailoverCriteria) {
    OriginGroupFailoverCriteria.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginGroupFailoverCriteria || (OriginGroupFailoverCriteria = {}));
export var OriginGroupMember;
(function (OriginGroupMember) {
    OriginGroupMember.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginGroupMember || (OriginGroupMember = {}));
export var OriginGroupMembers;
(function (OriginGroupMembers) {
    OriginGroupMembers.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginGroupMembers || (OriginGroupMembers = {}));
export var OriginGroup;
(function (OriginGroup) {
    OriginGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginGroup || (OriginGroup = {}));
export var OriginGroups;
(function (OriginGroups) {
    OriginGroups.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginGroups || (OriginGroups = {}));
export var OriginCustomHeader;
(function (OriginCustomHeader) {
    OriginCustomHeader.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.HeaderValue && { HeaderValue: SENSITIVE_STRING }))); };
})(OriginCustomHeader || (OriginCustomHeader = {}));
export var CustomHeaders;
(function (CustomHeaders) {
    CustomHeaders.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Items && { Items: obj.Items.map(function (item) { return OriginCustomHeader.filterSensitiveLog(item); }) }))); };
})(CustomHeaders || (CustomHeaders = {}));
export var OriginSslProtocols;
(function (OriginSslProtocols) {
    OriginSslProtocols.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginSslProtocols || (OriginSslProtocols = {}));
export var CustomOriginConfig;
(function (CustomOriginConfig) {
    CustomOriginConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CustomOriginConfig || (CustomOriginConfig = {}));
export var OriginShield;
(function (OriginShield) {
    OriginShield.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginShield || (OriginShield = {}));
export var S3OriginConfig;
(function (S3OriginConfig) {
    S3OriginConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(S3OriginConfig || (S3OriginConfig = {}));
export var Origin;
(function (Origin) {
    Origin.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.CustomHeaders && { CustomHeaders: CustomHeaders.filterSensitiveLog(obj.CustomHeaders) }))); };
})(Origin || (Origin = {}));
export var Origins;
(function (Origins) {
    Origins.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Origins || (Origins = {}));
export var GeoRestriction;
(function (GeoRestriction) {
    GeoRestriction.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GeoRestriction || (GeoRestriction = {}));
export var Restrictions;
(function (Restrictions) {
    Restrictions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Restrictions || (Restrictions = {}));
export var ViewerCertificate;
(function (ViewerCertificate) {
    ViewerCertificate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ViewerCertificate || (ViewerCertificate = {}));
export var DistributionConfig;
(function (DistributionConfig) {
    DistributionConfig.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Comment && { Comment: SENSITIVE_STRING }))); };
})(DistributionConfig || (DistributionConfig = {}));
export var CreateDistributionRequest;
(function (CreateDistributionRequest) {
    CreateDistributionRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DistributionConfig && {
        DistributionConfig: DistributionConfig.filterSensitiveLog(obj.DistributionConfig),
    }))); };
})(CreateDistributionRequest || (CreateDistributionRequest = {}));
export var Distribution;
(function (Distribution) {
    Distribution.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DistributionConfig && {
        DistributionConfig: DistributionConfig.filterSensitiveLog(obj.DistributionConfig),
    }))); };
})(Distribution || (Distribution = {}));
export var CreateDistributionResult;
(function (CreateDistributionResult) {
    CreateDistributionResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Distribution && { Distribution: Distribution.filterSensitiveLog(obj.Distribution) }))); };
})(CreateDistributionResult || (CreateDistributionResult = {}));
export var Tag;
(function (Tag) {
    Tag.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Tag || (Tag = {}));
export var Tags;
(function (Tags) {
    Tags.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Tags || (Tags = {}));
export var DistributionConfigWithTags;
(function (DistributionConfigWithTags) {
    DistributionConfigWithTags.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DistributionConfig && {
        DistributionConfig: DistributionConfig.filterSensitiveLog(obj.DistributionConfig),
    }))); };
})(DistributionConfigWithTags || (DistributionConfigWithTags = {}));
export var CreateDistributionWithTagsRequest;
(function (CreateDistributionWithTagsRequest) {
    CreateDistributionWithTagsRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DistributionConfigWithTags && {
        DistributionConfigWithTags: DistributionConfigWithTags.filterSensitiveLog(obj.DistributionConfigWithTags),
    }))); };
})(CreateDistributionWithTagsRequest || (CreateDistributionWithTagsRequest = {}));
export var CreateDistributionWithTagsResult;
(function (CreateDistributionWithTagsResult) {
    CreateDistributionWithTagsResult.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Distribution && { Distribution: Distribution.filterSensitiveLog(obj.Distribution) }))); };
})(CreateDistributionWithTagsResult || (CreateDistributionWithTagsResult = {}));
export var ContentTypeProfile;
(function (ContentTypeProfile) {
    ContentTypeProfile.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ContentTypeProfile || (ContentTypeProfile = {}));
export var ContentTypeProfiles;
(function (ContentTypeProfiles) {
    ContentTypeProfiles.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ContentTypeProfiles || (ContentTypeProfiles = {}));
export var ContentTypeProfileConfig;
(function (ContentTypeProfileConfig) {
    ContentTypeProfileConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ContentTypeProfileConfig || (ContentTypeProfileConfig = {}));
export var QueryArgProfile;
(function (QueryArgProfile) {
    QueryArgProfile.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryArgProfile || (QueryArgProfile = {}));
export var QueryArgProfiles;
(function (QueryArgProfiles) {
    QueryArgProfiles.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryArgProfiles || (QueryArgProfiles = {}));
export var QueryArgProfileConfig;
(function (QueryArgProfileConfig) {
    QueryArgProfileConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QueryArgProfileConfig || (QueryArgProfileConfig = {}));
export var FieldLevelEncryptionConfig;
(function (FieldLevelEncryptionConfig) {
    FieldLevelEncryptionConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionConfig || (FieldLevelEncryptionConfig = {}));
export var CreateFieldLevelEncryptionConfigRequest;
(function (CreateFieldLevelEncryptionConfigRequest) {
    CreateFieldLevelEncryptionConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateFieldLevelEncryptionConfigRequest || (CreateFieldLevelEncryptionConfigRequest = {}));
export var FieldLevelEncryption;
(function (FieldLevelEncryption) {
    FieldLevelEncryption.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryption || (FieldLevelEncryption = {}));
export var CreateFieldLevelEncryptionConfigResult;
(function (CreateFieldLevelEncryptionConfigResult) {
    CreateFieldLevelEncryptionConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateFieldLevelEncryptionConfigResult || (CreateFieldLevelEncryptionConfigResult = {}));
export var FieldPatterns;
(function (FieldPatterns) {
    FieldPatterns.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldPatterns || (FieldPatterns = {}));
export var EncryptionEntity;
(function (EncryptionEntity) {
    EncryptionEntity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EncryptionEntity || (EncryptionEntity = {}));
export var EncryptionEntities;
(function (EncryptionEntities) {
    EncryptionEntities.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EncryptionEntities || (EncryptionEntities = {}));
export var FieldLevelEncryptionProfileConfig;
(function (FieldLevelEncryptionProfileConfig) {
    FieldLevelEncryptionProfileConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionProfileConfig || (FieldLevelEncryptionProfileConfig = {}));
export var CreateFieldLevelEncryptionProfileRequest;
(function (CreateFieldLevelEncryptionProfileRequest) {
    CreateFieldLevelEncryptionProfileRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateFieldLevelEncryptionProfileRequest || (CreateFieldLevelEncryptionProfileRequest = {}));
export var FieldLevelEncryptionProfile;
(function (FieldLevelEncryptionProfile) {
    FieldLevelEncryptionProfile.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FieldLevelEncryptionProfile || (FieldLevelEncryptionProfile = {}));
export var CreateFieldLevelEncryptionProfileResult;
(function (CreateFieldLevelEncryptionProfileResult) {
    CreateFieldLevelEncryptionProfileResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateFieldLevelEncryptionProfileResult || (CreateFieldLevelEncryptionProfileResult = {}));
export var FunctionRuntime;
(function (FunctionRuntime) {
    FunctionRuntime["cloudfront_js_1_0"] = "cloudfront-js-1.0";
})(FunctionRuntime || (FunctionRuntime = {}));
export var FunctionConfig;
(function (FunctionConfig) {
    FunctionConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FunctionConfig || (FunctionConfig = {}));
export var CreateFunctionRequest;
(function (CreateFunctionRequest) {
    CreateFunctionRequest.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.FunctionCode && { FunctionCode: SENSITIVE_STRING }))); };
})(CreateFunctionRequest || (CreateFunctionRequest = {}));
export var FunctionStage;
(function (FunctionStage) {
    FunctionStage["DEVELOPMENT"] = "DEVELOPMENT";
    FunctionStage["LIVE"] = "LIVE";
})(FunctionStage || (FunctionStage = {}));
export var FunctionMetadata;
(function (FunctionMetadata) {
    FunctionMetadata.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FunctionMetadata || (FunctionMetadata = {}));
export var FunctionSummary;
(function (FunctionSummary) {
    FunctionSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FunctionSummary || (FunctionSummary = {}));
export var CreateFunctionResult;
(function (CreateFunctionResult) {
    CreateFunctionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateFunctionResult || (CreateFunctionResult = {}));
export var Paths;
(function (Paths) {
    Paths.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Paths || (Paths = {}));
export var InvalidationBatch;
(function (InvalidationBatch) {
    InvalidationBatch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidationBatch || (InvalidationBatch = {}));
export var CreateInvalidationRequest;
(function (CreateInvalidationRequest) {
    CreateInvalidationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateInvalidationRequest || (CreateInvalidationRequest = {}));
export var Invalidation;
(function (Invalidation) {
    Invalidation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Invalidation || (Invalidation = {}));
export var CreateInvalidationResult;
(function (CreateInvalidationResult) {
    CreateInvalidationResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateInvalidationResult || (CreateInvalidationResult = {}));
export var KeyGroupConfig;
(function (KeyGroupConfig) {
    KeyGroupConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KeyGroupConfig || (KeyGroupConfig = {}));
export var CreateKeyGroupRequest;
(function (CreateKeyGroupRequest) {
    CreateKeyGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateKeyGroupRequest || (CreateKeyGroupRequest = {}));
export var KeyGroup;
(function (KeyGroup) {
    KeyGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KeyGroup || (KeyGroup = {}));
export var CreateKeyGroupResult;
(function (CreateKeyGroupResult) {
    CreateKeyGroupResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateKeyGroupResult || (CreateKeyGroupResult = {}));
export var RealtimeMetricsSubscriptionStatus;
(function (RealtimeMetricsSubscriptionStatus) {
    RealtimeMetricsSubscriptionStatus["Disabled"] = "Disabled";
    RealtimeMetricsSubscriptionStatus["Enabled"] = "Enabled";
})(RealtimeMetricsSubscriptionStatus || (RealtimeMetricsSubscriptionStatus = {}));
export var RealtimeMetricsSubscriptionConfig;
(function (RealtimeMetricsSubscriptionConfig) {
    RealtimeMetricsSubscriptionConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RealtimeMetricsSubscriptionConfig || (RealtimeMetricsSubscriptionConfig = {}));
export var MonitoringSubscription;
(function (MonitoringSubscription) {
    MonitoringSubscription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MonitoringSubscription || (MonitoringSubscription = {}));
export var CreateMonitoringSubscriptionRequest;
(function (CreateMonitoringSubscriptionRequest) {
    CreateMonitoringSubscriptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateMonitoringSubscriptionRequest || (CreateMonitoringSubscriptionRequest = {}));
export var CreateMonitoringSubscriptionResult;
(function (CreateMonitoringSubscriptionResult) {
    CreateMonitoringSubscriptionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateMonitoringSubscriptionResult || (CreateMonitoringSubscriptionResult = {}));
export var OriginRequestPolicyCookiesConfig;
(function (OriginRequestPolicyCookiesConfig) {
    OriginRequestPolicyCookiesConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicyCookiesConfig || (OriginRequestPolicyCookiesConfig = {}));
export var OriginRequestPolicyHeadersConfig;
(function (OriginRequestPolicyHeadersConfig) {
    OriginRequestPolicyHeadersConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicyHeadersConfig || (OriginRequestPolicyHeadersConfig = {}));
export var OriginRequestPolicyQueryStringsConfig;
(function (OriginRequestPolicyQueryStringsConfig) {
    OriginRequestPolicyQueryStringsConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicyQueryStringsConfig || (OriginRequestPolicyQueryStringsConfig = {}));
export var OriginRequestPolicyConfig;
(function (OriginRequestPolicyConfig) {
    OriginRequestPolicyConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicyConfig || (OriginRequestPolicyConfig = {}));
export var CreateOriginRequestPolicyRequest;
(function (CreateOriginRequestPolicyRequest) {
    CreateOriginRequestPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateOriginRequestPolicyRequest || (CreateOriginRequestPolicyRequest = {}));
export var OriginRequestPolicy;
(function (OriginRequestPolicy) {
    OriginRequestPolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OriginRequestPolicy || (OriginRequestPolicy = {}));
export var CreateOriginRequestPolicyResult;
(function (CreateOriginRequestPolicyResult) {
    CreateOriginRequestPolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateOriginRequestPolicyResult || (CreateOriginRequestPolicyResult = {}));
export var PublicKeyConfig;
(function (PublicKeyConfig) {
    PublicKeyConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicKeyConfig || (PublicKeyConfig = {}));
export var CreatePublicKeyRequest;
(function (CreatePublicKeyRequest) {
    CreatePublicKeyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreatePublicKeyRequest || (CreatePublicKeyRequest = {}));
export var PublicKey;
(function (PublicKey) {
    PublicKey.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicKey || (PublicKey = {}));
export var CreatePublicKeyResult;
(function (CreatePublicKeyResult) {
    CreatePublicKeyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreatePublicKeyResult || (CreatePublicKeyResult = {}));
export var KinesisStreamConfig;
(function (KinesisStreamConfig) {
    KinesisStreamConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KinesisStreamConfig || (KinesisStreamConfig = {}));
export var EndPoint;
(function (EndPoint) {
    EndPoint.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndPoint || (EndPoint = {}));
export var CreateRealtimeLogConfigRequest;
(function (CreateRealtimeLogConfigRequest) {
    CreateRealtimeLogConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateRealtimeLogConfigRequest || (CreateRealtimeLogConfigRequest = {}));
export var RealtimeLogConfig;
(function (RealtimeLogConfig) {
    RealtimeLogConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RealtimeLogConfig || (RealtimeLogConfig = {}));
export var CreateRealtimeLogConfigResult;
(function (CreateRealtimeLogConfigResult) {
    CreateRealtimeLogConfigResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateRealtimeLogConfigResult || (CreateRealtimeLogConfigResult = {}));
export var ResponseHeadersPolicyAccessControlAllowHeaders;
(function (ResponseHeadersPolicyAccessControlAllowHeaders) {
    ResponseHeadersPolicyAccessControlAllowHeaders.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyAccessControlAllowHeaders || (ResponseHeadersPolicyAccessControlAllowHeaders = {}));
export var ResponseHeadersPolicyAccessControlAllowMethods;
(function (ResponseHeadersPolicyAccessControlAllowMethods) {
    ResponseHeadersPolicyAccessControlAllowMethods.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyAccessControlAllowMethods || (ResponseHeadersPolicyAccessControlAllowMethods = {}));
export var ResponseHeadersPolicyAccessControlAllowOrigins;
(function (ResponseHeadersPolicyAccessControlAllowOrigins) {
    ResponseHeadersPolicyAccessControlAllowOrigins.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyAccessControlAllowOrigins || (ResponseHeadersPolicyAccessControlAllowOrigins = {}));
export var ResponseHeadersPolicyAccessControlExposeHeaders;
(function (ResponseHeadersPolicyAccessControlExposeHeaders) {
    ResponseHeadersPolicyAccessControlExposeHeaders.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyAccessControlExposeHeaders || (ResponseHeadersPolicyAccessControlExposeHeaders = {}));
export var ResponseHeadersPolicyCorsConfig;
(function (ResponseHeadersPolicyCorsConfig) {
    ResponseHeadersPolicyCorsConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyCorsConfig || (ResponseHeadersPolicyCorsConfig = {}));
export var ResponseHeadersPolicyCustomHeader;
(function (ResponseHeadersPolicyCustomHeader) {
    ResponseHeadersPolicyCustomHeader.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyCustomHeader || (ResponseHeadersPolicyCustomHeader = {}));
export var ResponseHeadersPolicyCustomHeadersConfig;
(function (ResponseHeadersPolicyCustomHeadersConfig) {
    ResponseHeadersPolicyCustomHeadersConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyCustomHeadersConfig || (ResponseHeadersPolicyCustomHeadersConfig = {}));
export var ResponseHeadersPolicyContentSecurityPolicy;
(function (ResponseHeadersPolicyContentSecurityPolicy) {
    ResponseHeadersPolicyContentSecurityPolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyContentSecurityPolicy || (ResponseHeadersPolicyContentSecurityPolicy = {}));
export var ResponseHeadersPolicyContentTypeOptions;
(function (ResponseHeadersPolicyContentTypeOptions) {
    ResponseHeadersPolicyContentTypeOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyContentTypeOptions || (ResponseHeadersPolicyContentTypeOptions = {}));
export var FrameOptionsList;
(function (FrameOptionsList) {
    FrameOptionsList["DENY"] = "DENY";
    FrameOptionsList["SAMEORIGIN"] = "SAMEORIGIN";
})(FrameOptionsList || (FrameOptionsList = {}));
export var ResponseHeadersPolicyFrameOptions;
(function (ResponseHeadersPolicyFrameOptions) {
    ResponseHeadersPolicyFrameOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyFrameOptions || (ResponseHeadersPolicyFrameOptions = {}));
export var ReferrerPolicyList;
(function (ReferrerPolicyList) {
    ReferrerPolicyList["no_referrer"] = "no-referrer";
    ReferrerPolicyList["no_referrer_when_downgrade"] = "no-referrer-when-downgrade";
    ReferrerPolicyList["origin"] = "origin";
    ReferrerPolicyList["origin_when_cross_origin"] = "origin-when-cross-origin";
    ReferrerPolicyList["same_origin"] = "same-origin";
    ReferrerPolicyList["strict_origin"] = "strict-origin";
    ReferrerPolicyList["strict_origin_when_cross_origin"] = "strict-origin-when-cross-origin";
    ReferrerPolicyList["unsafe_url"] = "unsafe-url";
})(ReferrerPolicyList || (ReferrerPolicyList = {}));
export var ResponseHeadersPolicyReferrerPolicy;
(function (ResponseHeadersPolicyReferrerPolicy) {
    ResponseHeadersPolicyReferrerPolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyReferrerPolicy || (ResponseHeadersPolicyReferrerPolicy = {}));
export var ResponseHeadersPolicyStrictTransportSecurity;
(function (ResponseHeadersPolicyStrictTransportSecurity) {
    ResponseHeadersPolicyStrictTransportSecurity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyStrictTransportSecurity || (ResponseHeadersPolicyStrictTransportSecurity = {}));
export var ResponseHeadersPolicyXSSProtection;
(function (ResponseHeadersPolicyXSSProtection) {
    ResponseHeadersPolicyXSSProtection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyXSSProtection || (ResponseHeadersPolicyXSSProtection = {}));
export var ResponseHeadersPolicySecurityHeadersConfig;
(function (ResponseHeadersPolicySecurityHeadersConfig) {
    ResponseHeadersPolicySecurityHeadersConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicySecurityHeadersConfig || (ResponseHeadersPolicySecurityHeadersConfig = {}));
export var ResponseHeadersPolicyConfig;
(function (ResponseHeadersPolicyConfig) {
    ResponseHeadersPolicyConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicyConfig || (ResponseHeadersPolicyConfig = {}));
export var CreateResponseHeadersPolicyRequest;
(function (CreateResponseHeadersPolicyRequest) {
    CreateResponseHeadersPolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateResponseHeadersPolicyRequest || (CreateResponseHeadersPolicyRequest = {}));
export var ResponseHeadersPolicy;
(function (ResponseHeadersPolicy) {
    ResponseHeadersPolicy.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResponseHeadersPolicy || (ResponseHeadersPolicy = {}));
export var CreateResponseHeadersPolicyResult;
(function (CreateResponseHeadersPolicyResult) {
    CreateResponseHeadersPolicyResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateResponseHeadersPolicyResult || (CreateResponseHeadersPolicyResult = {}));
export var StreamingLoggingConfig;
(function (StreamingLoggingConfig) {
    StreamingLoggingConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamingLoggingConfig || (StreamingLoggingConfig = {}));
export var S3Origin;
(function (S3Origin) {
    S3Origin.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(S3Origin || (S3Origin = {}));
export var StreamingDistributionConfig;
(function (StreamingDistributionConfig) {
    StreamingDistributionConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamingDistributionConfig || (StreamingDistributionConfig = {}));
export var CreateStreamingDistributionRequest;
(function (CreateStreamingDistributionRequest) {
    CreateStreamingDistributionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateStreamingDistributionRequest || (CreateStreamingDistributionRequest = {}));
export var StreamingDistribution;
(function (StreamingDistribution) {
    StreamingDistribution.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamingDistribution || (StreamingDistribution = {}));
export var CreateStreamingDistributionResult;
(function (CreateStreamingDistributionResult) {
    CreateStreamingDistributionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateStreamingDistributionResult || (CreateStreamingDistributionResult = {}));
export var StreamingDistributionConfigWithTags;
(function (StreamingDistributionConfigWithTags) {
    StreamingDistributionConfigWithTags.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamingDistributionConfigWithTags || (StreamingDistributionConfigWithTags = {}));
export var CreateStreamingDistributionWithTagsRequest;
(function (CreateStreamingDistributionWithTagsRequest) {
    CreateStreamingDistributionWithTagsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateStreamingDistributionWithTagsRequest || (CreateStreamingDistributionWithTagsRequest = {}));
export var CreateStreamingDistributionWithTagsResult;
(function (CreateStreamingDistributionWithTagsResult) {
    CreateStreamingDistributionWithTagsResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateStreamingDistributionWithTagsResult || (CreateStreamingDistributionWithTagsResult = {}));
export var DeleteCachePolicyRequest;
(function (DeleteCachePolicyRequest) {
    DeleteCachePolicyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteCachePolicyRequest || (DeleteCachePolicyRequest = {}));
export var DeleteCloudFrontOriginAccessIdentityRequest;
(function (DeleteCloudFrontOriginAccessIdentityRequest) {
    DeleteCloudFrontOriginAccessIdentityRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteCloudFrontOriginAccessIdentityRequest || (DeleteCloudFrontOriginAccessIdentityRequest = {}));
export var DeleteDistributionRequest;
(function (DeleteDistributionRequest) {
    DeleteDistributionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteDistributionRequest || (DeleteDistributionRequest = {}));
export var DeleteFieldLevelEncryptionConfigRequest;
(function (DeleteFieldLevelEncryptionConfigRequest) {
    DeleteFieldLevelEncryptionConfigRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteFieldLevelEncryptionConfigRequest || (DeleteFieldLevelEncryptionConfigRequest = {}));
export var DeleteFieldLevelEncryptionProfileRequest;
(function (DeleteFieldLevelEncryptionProfileRequest) {
    DeleteFieldLevelEncryptionProfileRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteFieldLevelEncryptionProfileRequest || (DeleteFieldLevelEncryptionProfileRequest = {}));
export var DeleteFunctionRequest;
(function (DeleteFunctionRequest) {
    DeleteFunctionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteFunctionRequest || (DeleteFunctionRequest = {}));
export var DeleteKeyGroupRequest;
(function (DeleteKeyGroupRequest) {
    DeleteKeyGroupRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteKeyGroupRequest || (DeleteKeyGroupRequest = {}));
export var DeleteMonitoringSubscriptionRequest;
(function (DeleteMonitoringSubscriptionRequest) {
    DeleteMonitoringSubscriptionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteMonitoringSubscriptionRequest || (DeleteMonitoringSubscriptionRequest = {}));
